import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

// Default export a React component
// Tailwind CSS + Framer Motion based Apply Online form component
// Usage: <ApplyOnlineForm apiBaseUrl={process.env.REACT_APP_API_URL} />

export default function ApplyOnline({ apiBaseUrl = "/api" }) {
  // --- Choice section data fetched from API ---
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [semesters, setSemesters] = useState([]);
  const [genders, setGenders] = useState([]);
  const [sources, setSources] = useState([
    "Website",
    "Friend/Family",
    "Social Media",
    "Advertisement",
	"Google Search",
    "Other",
  ]);

  // --- form state ---
  const [form, setForm] = useState({	
    // Choice
    programId: "",
    semesterId: "",
    source: "",

    // Personal info
    name_en: "",
    name_bn: "",
    gender: "",
    dob: "",
    father_name: "",
    father_occupation: "",
    mother_name: "",
    mother_occupation: "",
    guardian_name: "",
    guardian_occupation: "",
    mobile: "",
    alt_mobile: "",
    email: "",
    father_guardian_mobile: "",
    nationality: "Bangladeshi",
    country: "Bangladesh",
    marital_status: "Single",
    religion: "Islam",
    passport_no: "",
    blood_group: "",
    national_id: "",
    birth_certificate: "",

    // Present address
    present_house: "",
    present_road: "",
    present_lane: "",
    present_block: "",
    present_area: "",
    present_thana: "",
    present_district: "",

    // Permanent address
    same_address: false,
    perm_house: "",
    perm_road: "",
    perm_lane: "",
    perm_block: "",
    perm_area: "",
    perm_thana: "",
    perm_district: "",

    // SSC
    ssc_exam: "SSC",
    ssc_board: "Dhaka Board",
    ssc_school: "",
    ssc_year: "",
    ssc_group: "",
    ssc_gpa: "",
    ssc_gpa_wo_optional: "",
	ssc_roll:"",
	ssc_reg:"",
	ssc_transcript: null,
	SSCTrans: null,

    // HSC
    hsc_exam: "HSC",
    hsc_board: "Dhaka Board",
    hsc_college: "",
    hsc_year: "",
    hsc_group: "",
    hsc_gpa: "",
    hsc_gpa_wo_optional: "",
	hsc_roll:"",
	hsc_reg:"",
	hsc_transcript: null,
	HSCTrans: null,
    // Degrees (conditionally shown for masters programs)
    bachelor_degree: {},
    master_degree: {},
    mphil_degree: {},
    phd_degree: {},
    professional_degrees: [ { institute: "", field: "", degree: "", grade: "" }, { institute: "", field: "", degree: "", grade: "" } ],
    employment_history: [ { company: "", designation: "", address: "", start_date: "", end_date: "", continued: false }, { company: "", designation: "", address: "", start_date: "", end_date: "", continued: false } ],

    // References
    references: [ { name: "", occupation: "", address: "", mobile: "", email: "" }, { name: "", occupation: "", address: "", mobile: "", email: "" } ],

    // Uploads & payment
    picture: null,
    picturePreview: null,
    signature: null,
    signaturePreview: null,
	nidfile: null,
    nidPreview: null,
    application_fee: 0,
    payment_method: "",
    transaction_details: "",

    // Declaration
    declaration: false,
  });

	const [errors, setErrors] = useState({});
	const [years, setYears] = useState([]);
	const [districts, setDistricts] = useState([]);
	const [message, setMessage] = useState(null);
	const [messageType, setMessageType] = useState("");
  // helper: list of years from 1986 to current
	useEffect(() => {
		const currentYear = new Date().getFullYear();
		const arr = [];
		for (let y = currentYear; y >= 1986; y--) arr.push(String(y));
		setYears(arr);
	}, []);
	
	
  // load initial programs list from API
	useEffect(() => {
		let cancelled = false;
		const loadPrograms = async () => {
		  try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/admission-programme-list", payload);	
		   
			setPrograms(res.data || []);
		  } catch (e) {
			console.warn("Failed to load programs, using placeholder.");
			// placeholder example
			setPrograms([]);			
		  }
		};
		loadPrograms();
		return () => { cancelled = true; };
	}, []);
	
	async function fetchDistrict() {
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/district-information", payload);
		  
		  setDistricts(res.data || []);
		} catch (e) {
		  console.error("fetchDistrict", e);
		}
	}
	
	useEffect(() => {
		fetchDistrict();		
	}, []);

	useEffect(() => {
		if (form.programId) {
		  fetchSessions(form.programId);
		}
		if (form.programId && form.semesterId) {
		  fetchGenders(form.programId, form.semesterId);
		  fetchApplicationFee(form.programId, form.semesterId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form.programId]);

	  // when session changes update fee
	useEffect(() => {
		if (form.programId && form.semesterId) {
			fetchGenders(form.programId, form.semesterId);
			fetchApplicationFee(form.programId, form.semesterId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [form.programId, form.semesterId]);
	
	async function fetchSessions(programId) {		
		try {
			if (!programId) return;
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				classId:programId,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/admission-semester-list", payload);
			
			setSemesters(res.data || []);
		} catch (e) {
		  console.error("fetchSessions", e);
		  setSessions([]);
		}
	}
	async function fetchGenders(programId, semesterId) {
		try {
			if (!programId || !semesterId) return;
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				classId:programId,
				semester_id:semesterId,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/admission-gender", payload);
			console.log(res.data);
			setGenders(res.data || []);
		} catch (e) {
		  console.error("fetchGenders", e);
		  setGenders([]);
		}
    }
	async function fetchApplicationFee(programId, semesterId) {
		try {
			if (!programId || !semesterId) return;
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				classId:programId,
				semester_id:semesterId,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/application-fee", payload);
			
			setForm((s) => ({ ...s, application_fee: res.data?.fee ?? "" }));
		} catch (e) {
		  console.error("fetchApplicationFee", e);
		  setForm((s) => ({ ...s, application_fee: "" }));
		}
	}
 
  
  // copy present address to permanent when checkbox toggled
  useEffect(() => {
    if (form.same_address) {
      setForm(f => ({
        ...f,
        perm_house: f.present_house,
        perm_road: f.present_road,
        perm_lane: f.present_lane,
        perm_block: f.present_block,
        perm_area: f.present_area,
        perm_thana: f.present_thana,
        perm_district: f.present_district,
      }));
    }
  }, [form.same_address]);

  // --- input handlers ---
  const handleChange = (path, value) => {
    setForm(f => ({ ...f, [path]: value }));
  };

  const handleFile = (field, file) => {
    if (!file) return;
    const allowed = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowed.includes(file.type)) {
      setErrors(e => ({ ...e, [field]: "Only JPG/PNG files allowed" }));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setForm(f => ({ ...f, [field]: file, [field + "Preview"]: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  // simple validators
  const validate = () => {
    const e = {};
    if (!form.programId) e.programId = "Select a program";
    if (!form.semesterId) e.semesterId = "Select a semester";
    if (!form.source) e.source = "Select how you heard about us";

    if (!form.name_en.trim()) e.name_en = "Applicant name (English) is required";
    if (!form.gender) e.gender = "Select gender";
    if (!form.dob) e.dob = "Select date of birth";
    if (!form.father_name) e.father_name = "Father name is required";
    if (!form.mother_name) e.mother_name = "Mother name is required";

    const phoneRe = /^01\d{9}$/; // Bangladesh 11-digit mobile starting with 01
    if (!phoneRe.test(form.mobile)) e.mobile = "Enter a valid 11-digit mobile number";
    if (form.alt_mobile && !phoneRe.test(form.alt_mobile)) e.alt_mobile = "Enter a valid 11-digit alternate number";
    if (!form.email || !/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Enter a valid email";
    if (!form.father_guardian_mobile || !phoneRe.test(form.father_guardian_mobile)) e.father_guardian_mobile = "Enter a valid 11-digit mobile";

    if (!form.nationality) e.nationality = "Nationality required";
    if (!form.country) e.country = "Country required";
    if (!form.marital_status) e.marital_status = "Select marital status";
    if (!form.religion) e.religion = "Select religion";
    if (!form.blood_group) e.blood_group = "Select blood group";

    if (!form.present_house) e.present_house = "Present house/name required";
    if (!form.present_road) e.present_road = "Present road/village required";
    if (!form.present_area) e.present_area = "Present area/post office required";
    if (!form.present_thana) e.present_thana = "Present thana/upazila required";
    if (!form.present_district) e.present_district = "Present district required";

    if (!form.ssc_school) e.ssc_school = "SSC school required";
    if (!form.ssc_year) e.ssc_year = "SSC passing year required";
    if (!form.ssc_gpa) e.ssc_gpa = "SSC GPA required";
    if (!form.hsc_college) e.hsc_college = "HSC college required";
    if (!form.hsc_year) e.hsc_year = "HSC passing year required";
    if (!form.hsc_gpa) e.hsc_gpa = "HSC GPA required";

    // national id or birth certificate required
    if (!form.national_id && !form.birth_certificate) e.identity = "Provide National ID or Birth Certificate number";

    // file checks
    if (!form.picture) e.picture = "Upload applicant picture";

    if (!form.declaration) e.declaration = "You must accept the declaration";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

	
	const handleSubmit = async (ev) => {
		ev.preventDefault();

		if (!validate()) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		const payload = new FormData();

		Object.keys(form).forEach((k) => {
			if (k.endsWith("Preview")) return;

			const val = form[k];

			if (val === null || typeof val === "undefined") return;

			if (val instanceof File) {
				payload.append(k, val);
			} else if (
				["bachelor_degree", "master_degree", "mphil_degree", "phd_degree","professional_degrees","employment_history"]
					.includes(k)
			) {
				payload.append(k, JSON.stringify(val ?? {}));
			} else if (typeof val === "object") {
				payload.append(k, JSON.stringify(val));
			} else {
				payload.append(k, String(val));
			}
		});

		payload.append("userId", import.meta.env.VITE_API_USER);
		payload.append("password", import.meta.env.VITE_API_PASS);

		// Debug: inspect the nested degree data before submission
		console.log("Bachelor degree:", form.bachelor_degree);
		console.log(
			"Submitted bachelor_degree:",
			payload.get("bachelor_degree")
		);

		try {
			setLoading(true);

			const res = await axios.post(
				`${import.meta.env.VITE_API_BASE_URL}/apply-online`,
				payload
			);

			const { responseCode, responseMsg } = res.data;

			if (String(responseCode) === "200") {
				setMessageType("success");
				setMessage(responseMsg);
				alert("Application submitted successfully");
				window.location.href = "/application-success";
			} else {
				const errorMessage =
					responseMsg || "Submission failed. Please try again.";

				setMessageType("error");
				setMessage(errorMessage);
				alert(errorMessage);
			}
		} catch (err) {
			console.error("Submission failed:", {
				status: err.response?.status,
				data: err.response?.data,
				message: err.message,
			});

			const responseData = err.response?.data;

			const errorMessage =
				responseData?.message ||
				responseData?.responseMsg ||
				responseData?.error ||
				(typeof responseData === "string" ? responseData : null) ||
				(err.response?.status
					? `Request failed with HTTP ${err.response.status}.`
					: err.message || "Network error.");

			setMessageType("error");
			setMessage(errorMessage);
			alert(errorMessage);
		} finally {
			setLoading(false);
		}
	};


  // utility small input component
  const FieldLabel = ({ children, required }) => (
    <label className="block text-sm font-medium text-gray-700">
      {children} {required && <span className="text-red-500">*</span>}
    </label>
  );

  // Detect if selected program is masters (simple check: title contains 'Master' or 'MSc')
  const isMasters = () => {
	if (!form.programId) return false;
    const p = form.programId;
    const parts = p.split('-');
    if(parts[0]==2){
		return true;
	}else{
		return false;
	}
  };

  return (
  <section className="min-h-screen bg-gradient-to-b from-[#6BCCF2] to-teal-50 text-[#014864] py-12">
    <div className="max-w-6xl  mx-auto p-6">
      {/* HERO */}
      <motion.section
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="rounded-2xl bg-gradient-to-r from-[#016C94] to-[#6BCCF2] p-8 text-white shadow-2xl mb-8"
      >
        <div className="flex flex-col lg:flex-row items-center gap-6">
          <div className="flex-1">
            <h1 className="text-3xl lg:text-5xl font-extrabold leading-tight">Apply Online</h1>
            <p className="mt-3 text-lg max-w-xl">Fast, secure and mobile-friendly application. Fill the form below and upload required documents. We’ll notify you by SMS and email.</p>

            <div className="mt-6 flex flex-wrap gap-3">
              <div className="bg-white/20 rounded px-3 py-2">Secure Submission</div>
              <div className="bg-white/20 rounded px-3 py-2">Support: +8801707508080</div>
              <div className="bg-white/20 rounded px-3 py-2">Documents: Photo & Signature</div>
            </div>
          </div>

          <motion.div
            className="w-full lg:w-1/3 p-4 bg-white/20 rounded-2xl"
            initial={{ scale: 0.98 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="text-sm">Application Fee</div>
            <div className="text-3xl font-bold">{form.application_fee} BDT</div>
            <div className="mt-3 text-xs">Change program/semester to update fee.</div>
          </motion.div>
        </div>
      </motion.section>

      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-2xl shadow p-6"
      >
		{message && (
			<div
			  className={`p-3 mb-4 text-sm rounded-md ${
				messageType === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
			  }`}
			>
			  {message}
			</div>
		)}
		
        {/* CHOICE SECTION */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Choice</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <FieldLabel required>Select Program/Subject</FieldLabel>
              <select
                value={form.programId}
                onChange={(e) => handleChange('programId', e.target.value)}
                className={`mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2`}
              >
                <option value="">-- Select Program --</option>
                {Array.isArray(programs) && programs.map(p => (<option key={`${p.programme_id}-${p.department_id}`} value={`${p.programme_id}-${p.department_id}`}>{p.degree_name}</option>))}
              </select>
              {errors.programId && <div className="text-red-600 text-sm mt-1">{errors.programId}</div>}
            </div>

            <div>
              <FieldLabel required>Select Semester</FieldLabel>
              <select
                value={form.semesterId}
                onChange={(e) => handleChange('semesterId', e.target.value)}
                className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2"
              >
                <option value="">-- Select Semester --</option>
                {Array.isArray(semesters) && semesters.map(s => (<option key={s.semester_id} value={s.semester_id}>{s.semester_name}</option>))}
              </select>
              {errors.semesterId && <div className="text-red-600 text-sm mt-1">{errors.semesterId}</div>}
            </div>

            <div>
              <FieldLabel required>Select Source of Getting Information</FieldLabel>
              <select
                value={form.source}
                onChange={(e) => handleChange('source', e.target.value)}
                className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2"
              >
                <option value="">-- Select Source --</option>
                {sources.map(s => (<option key={s} value={s}>{s}</option>))}
              </select>
              {errors.source && <div className="text-red-600 text-sm mt-1">{errors.source}</div>}
            </div>
          </div>
        </section>

        {/* PERSONAL INFORMATION */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Personal Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <FieldLabel required>Applicant Name (English)</FieldLabel>
              <input value={form.name_en} onChange={e => handleChange('name_en', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.name_en && <div className="text-red-600 text-sm">{errors.name_en}</div>}
            </div>

            <div>
              <FieldLabel>Applicant Name (Bangla)</FieldLabel>
              <input value={form.name_bn} onChange={e => handleChange('name_bn', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel required>Select Gender</FieldLabel>
              <select value={form.gender} onChange={e => handleChange('gender', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option value="">Select gender</option>
                  {Array.isArray(genders) && genders.map((g) => (
                    <option key={g.id} value={g.gender}>{g.gender}</option>
                  ))}
              </select>
              {errors.gender && <div className="text-red-600 text-sm">{errors.gender}</div>}
            </div>

            <div>
              <FieldLabel required>Date of Birth (YYYY-mm-dd)</FieldLabel>
              <input type="date" value={form.dob} onChange={e => handleChange('dob', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.dob && <div className="text-red-600 text-sm">{errors.dob}</div>}
            </div>

            <div>
              <FieldLabel required>Father Name</FieldLabel>
              <input value={form.father_name} onChange={e => handleChange('father_name', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.father_name && <div className="text-red-600 text-sm">{errors.father_name}</div>}
            </div>

            <div>
              <FieldLabel>Father Occupation</FieldLabel>
              <input value={form.father_occupation} onChange={e => handleChange('father_occupation', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel required>Mother Name</FieldLabel>
              <input value={form.mother_name} onChange={e => handleChange('mother_name', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.mother_name && <div className="text-red-600 text-sm">{errors.mother_name}</div>}
            </div>

            <div>
              <FieldLabel>Mother Occupation</FieldLabel>
              <input value={form.mother_occupation} onChange={e => handleChange('mother_occupation', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel>Guardian Name</FieldLabel>
              <input value={form.guardian_name} onChange={e => handleChange('guardian_name', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel>Guardian Occupation</FieldLabel>
              <input value={form.guardian_occupation} onChange={e => handleChange('guardian_occupation', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel required>Mobile Number</FieldLabel>
              <input value={form.mobile} onChange={e => handleChange('mobile', e.target.value)} maxLength={11} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" placeholder="01XXXXXXXXX" />
              {errors.mobile && <div className="text-red-600 text-sm">{errors.mobile}</div>}
            </div>

            <div>
              <FieldLabel>Alternative Mobile Number</FieldLabel>
              <input value={form.alt_mobile} onChange={e => handleChange('alt_mobile', e.target.value)} maxLength={11} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" placeholder="Optional" />
              {errors.alt_mobile && <div className="text-red-600 text-sm">{errors.alt_mobile}</div>}
            </div>

            <div>
              <FieldLabel required>Application Email</FieldLabel>
              <input type="email" value={form.email} onChange={e => handleChange('email', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.email && <div className="text-red-600 text-sm">{errors.email}</div>}
            </div>

            <div>
              <FieldLabel required>Father/Guardian Mobile Number</FieldLabel>
              <input value={form.father_guardian_mobile} onChange={e => handleChange('father_guardian_mobile', e.target.value)} maxLength={11} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.father_guardian_mobile && <div className="text-red-600 text-sm">{errors.father_guardian_mobile}</div>}
            </div>

            <div>
              <FieldLabel required>Nationality</FieldLabel>
              <input value={form.nationality} onChange={e => handleChange('nationality', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.nationality && <div className="text-red-600 text-sm">{errors.nationality}</div>}
            </div>

            <div>
              <FieldLabel required>Country</FieldLabel>
              <input value={form.country} onChange={e => handleChange('country', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.country && <div className="text-red-600 text-sm">{errors.country}</div>}
            </div>

            <div>
              <FieldLabel required>Select Marital Status</FieldLabel>
              <select value={form.marital_status} onChange={e => handleChange('marital_status', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option value="Single">Single</option>
                <option value="Married">Married</option>
              </select>
              {errors.marital_status && <div className="text-red-600 text-sm">{errors.marital_status}</div>}
            </div>

            <div>
              <FieldLabel required>Select Religion</FieldLabel>
              <select value={form.religion} onChange={e => handleChange('religion', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option>Islam</option>
                <option>Hinduism</option>
                <option>Buddhism</option>
                <option>Christianity</option>
                <option>Others</option>
              </select>
              {errors.religion && <div className="text-red-600 text-sm">{errors.religion}</div>}
            </div>

            <div>
              <FieldLabel>Passport No.</FieldLabel>
              <input value={form.passport_no} onChange={e => handleChange('passport_no', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel required>Select Blood Group</FieldLabel>
              <select value={form.blood_group} onChange={e => handleChange('blood_group', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option value="">-- Select --</option>
                {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(b => <option key={b}>{b}</option>)}
              </select>
              {errors.blood_group && <div className="text-red-600 text-sm">{errors.blood_group}</div>}
            </div>

            <div>
              <FieldLabel>National ID</FieldLabel>
              <input value={form.national_id} onChange={e => handleChange('national_id', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel>Birth Certificate No</FieldLabel>
              <input value={form.birth_certificate} onChange={e => handleChange('birth_certificate', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            {errors.identity && <div className="text-red-600 text-sm">{errors.identity}</div>}
          </div>
        </section>

        {/* ADDRESSES */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Present Address</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <FieldLabel required>House No./Name</FieldLabel>
              <input value={form.present_house} onChange={e => handleChange('present_house', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.present_house && <div className="text-red-600 text-sm">{errors.present_house}</div>}
            </div>

            <div>
              <FieldLabel required>Road/Village</FieldLabel>
              <input value={form.present_road} onChange={e => handleChange('present_road', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.present_road && <div className="text-red-600 text-sm">{errors.present_road}</div>}
            </div>

            <div>
              <FieldLabel>Lane</FieldLabel>
              <input value={form.present_lane} onChange={e => handleChange('present_lane', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel>Block</FieldLabel>
              <input value={form.present_block} onChange={e => handleChange('present_block', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>

            <div>
              <FieldLabel required>Area/Post office</FieldLabel>
              <input value={form.present_area} onChange={e => handleChange('present_area', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.present_area && <div className="text-red-600 text-sm">{errors.present_area}</div>}
            </div>

            <div>
              <FieldLabel required>Thana/Upazila</FieldLabel>
              <input value={form.present_thana} onChange={e => handleChange('present_thana', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              {errors.present_thana && <div className="text-red-600 text-sm">{errors.present_thana}</div>}
            </div>

            <div>
              <FieldLabel required>Select District</FieldLabel>
              <select value={form.present_district} onChange={e => handleChange('present_district', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option value="">-- Select district --</option>
                {Array.isArray(districts) &&  districts.map(d => <option key={d.id}>{d.name}</option>)}
              </select>
              {errors.present_district && <div className="text-red-600 text-sm">{errors.present_district}</div>}
            </div>
          </div>

          <div className="mt-4 flex items-center gap-3">
            <input type="checkbox" checked={form.same_address} onChange={e => handleChange('same_address', e.target.checked)} id="sameAddr" className="h-4 w-4" />
            <label htmlFor="sameAddr">Same as present address</label>
          </div>

          {/* Permanent */}
          <h3 className="text-lg font-medium mt-6 mb-3">Permanent Address</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <FieldLabel>House No./Name</FieldLabel>
              <input value={form.perm_house} onChange={e => handleChange('perm_house', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            <div>
              <FieldLabel>Road/Village</FieldLabel>
              <input value={form.perm_road} onChange={e => handleChange('perm_road', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            <div>
              <FieldLabel>Lane</FieldLabel>
              <input value={form.perm_lane} onChange={e => handleChange('perm_lane', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            <div>
              <FieldLabel>Block</FieldLabel>
              <input value={form.perm_block} onChange={e => handleChange('perm_block', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            <div>
              <FieldLabel>Area/Post office</FieldLabel>
              <input value={form.perm_area} onChange={e => handleChange('perm_area', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            <div>
              <FieldLabel>Thana/Upazila</FieldLabel>
              <input value={form.perm_thana} onChange={e => handleChange('perm_thana', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
            </div>
            <div>
              <FieldLabel>Select District</FieldLabel>
              <select value={form.perm_district} onChange={e => handleChange('perm_district', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option value="">-- Select district --</option>
                {Array.isArray(districts) &&  districts.map(d => <option key={d.id}>{d.name}</option>)}
              </select>
            </div>
          </div>
        </section>

        {/* ACADEMIC INFO - SSC & HSC */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Academic Information</h2>

          <div className="bg-gray-50 border p-4 rounded mb-4">
            <h3 className="font-medium mb-2">SSC / Equivalent</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div>
                <FieldLabel required>Select Examination Name</FieldLabel>
                <select value={form.ssc_exam} onChange={e => handleChange('ssc_exam', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  {['SSC','Dakhil','Vocational','O Level','Diploma','Dawra-e Hadith (Takmil)'].map(v => <option key={v}>{v}</option>)}
                </select>
              </div>
			  <div>
                <FieldLabel required>Roll No.</FieldLabel>
                <input value={form.ssc_roll} onChange={e => handleChange('ssc_roll', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>
			  <div>
                <FieldLabel required>Registration No.</FieldLabel>
                <input value={form.ssc_reg} onChange={e => handleChange('ssc_reg', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>	
              <div>
                <FieldLabel required>Select Board Name</FieldLabel>
                <select value={form.ssc_board} onChange={e => handleChange('ssc_board', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  {['Barishal Board','Chittagong Board','Comilla Board','Dhaka Board','Jessore Board','Mymensingh Board','Rajshahi Board','Sylhet Board','Dinajpur Board','Madrasah Board','Technical Board','Others'].map(v => <option key={v}>{v}</option>)}
                </select>
              </div>

              <div>
                <FieldLabel required>School Name</FieldLabel>
                <input value={form.ssc_school} onChange={e => handleChange('ssc_school', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                {errors.ssc_school && <div className="text-red-600 text-sm">{errors.ssc_school}</div>}
              </div>

              <div>
                <FieldLabel required>Passing Year</FieldLabel>
                <select value={form.ssc_year} onChange={e => handleChange('ssc_year', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  <option value="">-- Year --</option>
                  {years.map(y => <option key={y}>{y}</option>)}
                </select>
                {errors.ssc_year && <div className="text-red-600 text-sm">{errors.ssc_year}</div>}
              </div>

              <div>
                <FieldLabel required>Group</FieldLabel>
                <input value={form.ssc_group} onChange={e => handleChange('ssc_group', e.target.value)} list="groupName" placeholder="SSC Group" className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
				<datalist id="groupName">
					<option value="Science">Science</option>
					<option value="Business Studies">Business Studies</option>
					<option value="Humanities">Humanities</option>
				</datalist>
			  </div>

              <div>
                <FieldLabel required>GPA/CGPA</FieldLabel>
                <input value={form.ssc_gpa} onChange={e => handleChange('ssc_gpa', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                {errors.ssc_gpa && <div className="text-red-600 text-sm">{errors.ssc_gpa}</div>}
              </div>

              <div>
                <FieldLabel required>GPA without Optional</FieldLabel>
                <input value={form.ssc_gpa_wo_optional} onChange={e => handleChange('ssc_gpa_wo_optional', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>
			   <div>
				  <FieldLabel required>Upload SSC Transcript (jpg/png)</FieldLabel>
				  <input type="file" accept="image/*" onChange={e => handleFile('ssc_transcript', e.target.files?.[0])} className="mt-1 border rounded-md p-2" />
				  {form.SSCTrans && <img src={form.SSCTrans} alt="preview" className="mt-2 w-32 h-32 object-cover rounded" />}
				  {errors.ssc_transcript && <div className="text-red-600 text-sm">{errors.ssc_transcript}</div>}
				</div>
            </div>
          </div>

          <div className="bg-gray-50 border p-4 rounded">
            <h3 className="font-medium mb-2">HSC / Equivalent</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div>
                <FieldLabel required>Select Examination Name</FieldLabel>
                <select value={form.hsc_exam} onChange={e => handleChange('hsc_exam', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  {['HSC','Alim','Vocational','A Level','Diploma','HSC(BM)','Dawra-e Hadith (Takmil)'].map(v => <option key={v}>{v}</option>)}
                </select>
              </div>
			  <div>
                <FieldLabel required>Roll No.</FieldLabel>
                <input value={form.hsc_roll} onChange={e => handleChange('hsc_roll', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>
			  <div>
                <FieldLabel required>Registration No.</FieldLabel>
                <input value={form.hsc_reg} onChange={e => handleChange('hsc_reg', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>
              <div>
                <FieldLabel required>Select Board Name</FieldLabel>
                <select value={form.hsc_board} onChange={e => handleChange('hsc_board', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  {['Barishal Board','Chittagong Board','Comilla Board','Dhaka Board','Jessore Board','Mymensingh Board','Rajshahi Board','Sylhet Board','Dinajpur Board','Madrasah Board','Technical Board','Others'].map(v => <option key={v}>{v}</option>)}
                </select>
              </div>

              <div>
                <FieldLabel required>College Name</FieldLabel>
                <input value={form.hsc_college} onChange={e => handleChange('hsc_college', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                {errors.hsc_college && <div className="text-red-600 text-sm">{errors.hsc_college}</div>}
              </div>

              <div>
                <FieldLabel required>Passing Year</FieldLabel>
                <select value={form.hsc_year} onChange={e => handleChange('hsc_year', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  <option value="">-- Year --</option>
                  {years.map(y => <option key={y}>{y}</option>)}
                </select>
                {errors.hsc_year && <div className="text-red-600 text-sm">{errors.hsc_year}</div>}
              </div>

              <div>
                <FieldLabel required>Group</FieldLabel>
                <input value={form.hsc_group} onChange={e => handleChange('hsc_group', e.target.value)}  list="groupName" placeholder="HSC Group" className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>

              <div>
                <FieldLabel required>GPA/CGPA</FieldLabel>
                <input value={form.hsc_gpa} onChange={e => handleChange('hsc_gpa', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                {errors.hsc_gpa && <div className="text-red-600 text-sm">{errors.hsc_gpa}</div>}
              </div>

              <div>
                <FieldLabel required>GPA without Optional</FieldLabel>
                <input value={form.hsc_gpa_wo_optional} onChange={e => handleChange('hsc_gpa_wo_optional', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>
			  <div>
				  <FieldLabel required>Upload HSC/Diploma Transcript (jpg/png)</FieldLabel>
				  <input type="file" accept="image/*" onChange={e => handleFile('hsc_transcript', e.target.files?.[0])} className="mt-1 border rounded-md p-2" />
				  {form.HSCTrans && <img src={form.HSCTrans} alt="preview" className="mt-2 w-32 h-32 object-cover rounded" />}
				  {errors.hsc_transcript && <div className="text-red-600 text-sm">{errors.hsc_transcript}</div>}
				</div>
            </div>
          </div>
        </section>

        {/* CONDITIONAL: Masters sections */}
        {isMasters() && (
          <section className="mb-6">
            <h2 className="text-xl font-semibold mb-4">Postgraduate / Additional Qualifications</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-50 border p-4 rounded">
                <h4 className="font-medium mb-2">Bachelor Degree</h4>
                <input placeholder="Degree Name" value={form.bachelor_degree.name || ''} onChange={e => setForm(f => ({ ...f, bachelor_degree: { ...f.bachelor_degree, name: e.target.value } }))} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="University/College" value={form.bachelor_degree.university || ''} onChange={e => setForm(f => ({ ...f, bachelor_degree: { ...f.bachelor_degree, university: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <select value={form.bachelor_degree.year || ''} onChange={e => setForm(f => ({ ...f, bachelor_degree: { ...f.bachelor_degree, year: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  <option value="">Passing Year</option>
                  {years.map(y=> <option key={y}>{y}</option>)}
                </select>
                <input placeholder="Subject" value={form.bachelor_degree.subject || ''} onChange={e => setForm(f => ({ ...f, bachelor_degree: { ...f.bachelor_degree, subject: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="GPA/CGPA" value={form.bachelor_degree.gpa || ''} onChange={e => setForm(f => ({ ...f, bachelor_degree: { ...f.bachelor_degree, gpa: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>

              <div className="bg-gray-50 border p-4 rounded">
                <h4 className="font-medium mb-2">Master Degree</h4>
                <input placeholder="Degree Name" value={form.master_degree.name || ''} onChange={e => setForm(f => ({ ...f, master_degree: { ...f.master_degree, name: e.target.value } }))} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="University/College" value={form.master_degree.university || ''} onChange={e => setForm(f => ({ ...f, master_degree: { ...f.master_degree, university: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <select value={form.master_degree.year || ''} onChange={e => setForm(f => ({ ...f, master_degree: { ...f.master_degree, year: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  <option value="">Passing Year</option>
                  {years.map(y=> <option key={y}>{y}</option>)}
                </select>
                <input placeholder="Subject" value={form.master_degree.subject || ''} onChange={e => setForm(f => ({ ...f, master_degree: { ...f.master_degree, subject: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="GPA/CGPA" value={form.master_degree.gpa || ''} onChange={e => setForm(f => ({ ...f, master_degree: { ...f.master_degree, gpa: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>

              <div className="bg-gray-50 border p-4 rounded">
                <h4 className="font-medium mb-2">MPhil / Others</h4>
                <input placeholder="Degree Name" value={form.mphil_degree.name || ''} onChange={e => setForm(f => ({ ...f, mphil_degree: { ...f.mphil_degree, name: e.target.value } }))} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="University/College" value={form.mphil_degree.university || ''} onChange={e => setForm(f => ({ ...f, mphil_degree: { ...f.mphil_degree, university: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <select value={form.mphil_degree.year || ''} onChange={e => setForm(f => ({ ...f, mphil_degree: { ...f.mphil_degree, year: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm">
                  <option value="">Passing Year</option>
                  {years.map(y=> <option key={y}>{y}</option>)}
                </select>
                <input placeholder="Subject" value={form.mphil_degree.subject || ''} onChange={e => setForm(f => ({ ...f, mphil_degree: { ...f.mphil_degree, subject: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="GPA/CGPA" value={form.mphil_degree.gpa || ''} onChange={e => setForm(f => ({ ...f, mphil_degree: { ...f.mphil_degree, gpa: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>

              <div className="bg-gray-50 border p-4 rounded">
                <h4 className="font-medium mb-2">PhD / Others</h4>
                <input placeholder="Degree Name" value={form.phd_degree.name || ''} onChange={e => setForm(f => ({ ...f, phd_degree: { ...f.phd_degree, name: e.target.value } }))} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="University/College" value={form.phd_degree.university || ''} onChange={e => setForm(f => ({ ...f, phd_degree: { ...f.phd_degree, university: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <select value={form.phd_degree.year || ''} onChange={e => setForm(f => ({ ...f, phd_degree: { ...f.phd_degree, year: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                  <option value="">Passing Year</option>
                  {years.map(y=> <option key={y}>{y}</option>)}
                </select>
                <input placeholder="Subject" value={form.phd_degree.subject || ''} onChange={e => setForm(f => ({ ...f, phd_degree: { ...f.phd_degree, subject: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
                <input placeholder="GPA/CGPA" value={form.phd_degree.gpa || ''} onChange={e => setForm(f => ({ ...f, phd_degree: { ...f.phd_degree, gpa: e.target.value } }))} className="mt-2 block w-full rounded-md border border-[#016C94] shadow-sm p-2" />
              </div>

              <div className="bg-gray-50 rounded col-span-full">
                <h4 className="text-xl font-semibold text-pink-600 mb-4">Professional Degrees</h4>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {form.professional_degrees.map((pd, idx) => (
                  <div key={idx} className="border rounded p-4">
				    <div className="font-medium mb-2">Professional Degree {idx + 1}</div>
                    <input placeholder="Institute Name" value={pd.institute} onChange={e => setForm(f => ({ ...f, professional_degrees: f.professional_degrees.map((p,i) => i===idx?{...p,institute:e.target.value}:p) }))} className="w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                    <input placeholder="Field/Subject" value={pd.field} onChange={e => setForm(f => ({ ...f, professional_degrees: f.professional_degrees.map((p,i) => i===idx?{...p,field:e.target.value}:p) }))} className="w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                    <input placeholder="Degree/Diploma" value={pd.degree} onChange={e => setForm(f => ({ ...f, professional_degrees: f.professional_degrees.map((p,i) => i===idx?{...p,degree:e.target.value}:p) }))} className="w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                    <input placeholder="Grade" value={pd.grade} onChange={e => setForm(f => ({ ...f, professional_degrees: f.professional_degrees.map((p,i) => i===idx?{...p,grade:e.target.value}:p) }))} className=" w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                  </div>
                ))}
				</div>
              </div>

              <div className="bg-gray-50 rounded col-span-full">
                <h4 className="text-xl font-semibold text-pink-600 mb-4">Employment History</h4>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {form.employment_history.map((eh, idx) => (
                  <div key={idx} className="border rounded p-4">
					<div className="font-medium mb-2">Employment History {idx + 1}</div>
                    <input placeholder="Company Name" value={eh.company} onChange={e => setForm(f => ({ ...f, employment_history: f.employment_history.map((p,i)=>i===idx?{...p,company:e.target.value}:p) }))} className="w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                    <input placeholder="Designation" value={eh.designation} onChange={e => setForm(f => ({ ...f, employment_history: f.employment_history.map((p,i)=>i===idx?{...p,designation:e.target.value}:p) }))} className="w-full mt-2  rounded-md border border-[#016C94] shadow-sm p-2" />
                    <input placeholder="Address" value={eh.address} onChange={e => setForm(f => ({ ...f, employment_history: f.employment_history.map((p,i)=>i===idx?{...p,address:e.target.value}:p) }))} className="w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                    <input type="date" placeholder="Start Date" value={eh.start_date} onChange={e => setForm(f => ({ ...f, employment_history: f.employment_history.map((p,i)=>i===idx?{...p,start_date:e.target.value}:p) }))} className="w-full mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                    <div className="flex gap-2">
                      <input type="date" value={eh.end_date} onChange={e => setForm(f => ({ ...f, employment_history: f.employment_history.map((p,i)=>i===idx?{...p,end_date:e.target.value}:p) }))} className="mt-2 rounded-md border border-[#016C94] shadow-sm p-2" />
                      <label className="flex items-center gap-2"><input type="checkbox" checked={eh.continued} onChange={e => setForm(f => ({ ...f, employment_history: f.employment_history.map((p,i)=>i===idx?{...p,continued:e.target.checked}:p) }))} /> Continue</label>
                    </div>
                  </div>
                ))}
				</div>
              </div>

              

            </div>
          </section>
        )}
		{/* References */}
		<section className="mb-6">
			<h2 className="text-xl font-semibold text-pink-600 mb-4">References</h2>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
			  {form.references.map((ref, idx) => (
				<div key={idx} className="border rounded p-4">
				  <div className="font-medium mb-2">Reference {idx + 1}</div>
				  <input name="name" placeholder="Name" value={ref.name} onChange={e => setForm(f => ({ ...f, references: f.references.map((r,i)=>i===idx?{...r,name:e.target.value}:r) }))} className="mt-2 w-full border rounded-md p-2" />
				  <input name="occupation" placeholder="Occupation" value={ref.occupation} onChange={e => setForm(f => ({ ...f, references: f.references.map((r,i)=>i===idx?{...r,occupation:e.target.value}:r) }))} className="mt-2 w-full border rounded-md p-2" />
				  <input name="address" placeholder="Address/ID" value={ref.address} onChange={e => setForm(f => ({ ...f, references: f.references.map((r,i)=>i===idx?{...r,address:e.target.value}:r) }))} className="mt-2 w-full border rounded-md p-2" />
				  <input name="mobile" placeholder="Mobile" value={ref.mobile} onChange={e => setForm(f => ({ ...f, references: f.references.map((r,i)=>i===idx?{...r,mobile:e.target.value}:r) }))}  className="mt-2 w-full border rounded-md p-2" />
				  <input name="email" placeholder="Email" value={ref.email} onChange={e => setForm(f => ({ ...f, references: f.references.map((r,i)=>i===idx?{...r,email:e.target.value}:r) }))} className="mt-2 w-full border rounded-md p-2" />
				</div>
			  ))}
			</div>
		</section>
		
        {/* Uploads & Payment */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Uploads & Payment</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <FieldLabel required>Upload Picture (jpg/png)</FieldLabel>
              <input type="file" accept="image/*" onChange={e => handleFile('picture', e.target.files?.[0])} className="mt-1 border rounded-md p-2" />
              {form.picturePreview && <img src={form.picturePreview} alt="preview" className="mt-2 w-32 h-32 object-cover rounded" />}
              {errors.picture && <div className="text-red-600 text-sm">{errors.picture}</div>}
            </div>

            <div>
              <FieldLabel>Upload Signature (jpg/png)</FieldLabel>
              <input type="file" accept="image/*" onChange={e => handleFile('signature', e.target.files?.[0])} className="mt-1 border rounded-md p-2" />
              {form.signaturePreview && <img src={form.signaturePreview} alt="sig" className="mt-2 w-32 h-32 object-contain rounded" />}
            </div>
			
			<div>
              <FieldLabel>Upload NID/Birth certificate (jpg/png)</FieldLabel>
              <input type="file" accept="image/*" onChange={e => handleFile('nidfile', e.target.files?.[0])} className="mt-1 border rounded-md p-2" />
              {form.nidPreview && <img src={form.nidPreview} alt="nid" className="mt-2 w-32 h-32 object-contain rounded" />}
            </div>

            <div>
              <FieldLabel required>Application Fee</FieldLabel>
              <div className="mt-1 text-lg font-bold">{form.application_fee} BDT</div>

              <FieldLabel required className="mt-3">Select Payment Method</FieldLabel>
              <select value={form.payment_method} onChange={e => handleChange('payment_method', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm p-2">
                <option value="">-- Select --</option>
                <option>bKash</option>
                <option>Cash</option>
                <option>Bank</option>
              </select>

              <FieldLabel required className="mt-3">Transaction Details</FieldLabel>
              <textarea value={form.transaction_details} onChange={e => handleChange('transaction_details', e.target.value)} className="mt-1 block w-full rounded-md border border-[#016C94] shadow-sm" />
            </div>
          </div>
        </section>

        {/* Declaration */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Declaration</h2>
          <div className="bg-gray-50 border p-4 rounded">
            <p className="text-sm">
              I do hereby certify that the information provided in this application is complete and true. I understand that the University has the right to reject this application or cancel my admission if any information provided herein is found false or incorrect. If my application is accepted for admission to the program applied for, I undertake to abide by all the rules and regulations of this University and ensure to pay all fees & charges duly.
            </p>

            <div className="mt-3 flex items-center gap-3">
              <input type="checkbox" checked={form.declaration} onChange={e => handleChange('declaration', e.target.checked)} id="dec" className="h-4 w-4" />
              <label htmlFor="dec">I accept the declaration above.</label>
            </div>
            {errors.declaration && <div className="text-red-600 text-sm">{errors.declaration}</div>}
          </div>
        </section>

        <div className="flex justify-end gap-3">
          <button type="reset" className="px-4 py-2 rounded bg-gray-200">Reset</button>
          <button type="submit" disabled={loading}  className="px-6 py-2 rounded bg-indigo-600 text-white font-semibold">{loading ? "Submitting..." : "Submit Application"}</button>
        </div>
      </motion.form>
    </div>
	</section>
  );
}
